import React from 'react';

class NewDetail extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true
        }
    }

    render() {
        return (
            <div>

                <p>This is the new...</p>

                {this.state.loading && <p>Loading</p>}

            </div>
        );
    }


}

export default NewDetail;


// WEBPACK FOOTER //
// ./src/screens/newDetail/index.js